import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Form,
  FormFeedback,
  Input,
  Label,
} from "reactstrap"
import {
  getBazaarStallDetails,
  addBazaarStallDetails,
} from "../../../redux/actions/pvs"
import { useFormik } from "formik"
import * as Yup from "yup"
import { ADD_BAZAAR_STALL_DETAILS_RESET } from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import PageLoader from "components/Common/PageLoader"

const AddSlots = () => {
  document.title = "Add Slot | PULA"

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  const { state } = location

  const [selectedBazaar, setselectedBazaar] = useState(null)

  const addBazaarStallDetailsScreen = useSelector(
    state => state.screens.pvs.addBazaarStallDetails
  )
  const bazaarList = useSelector(state => state.pvs.bazaarList)

  useEffect(() => {
    if (addBazaarStallDetailsScreen.success) {
      toast.success(addBazaarStallDetailsScreen.message)
      dispatch({ type: ADD_BAZAAR_STALL_DETAILS_RESET })
      // navigate(`/slots-list?id=${row.id}`, {})
      navigate(-1)
    }
    if (addBazaarStallDetailsScreen.error) {
      toast.error(addBazaarStallDetailsScreen.error)
      dispatch({ type: ADD_BAZAAR_STALL_DETAILS_RESET })
    }
  }, [addBazaarStallDetailsScreen])

  useEffect(() => {
    console.log("state..", state)

    if (bazaarList && bazaarList.length > 0) {
      let currentIndex = bazaarList.findIndex(
        bazaar => bazaar.enc_bazaar_id === state?.enc_bazaar_id
      )
      console.log("currentIndex", currentIndex)
      if (currentIndex >= 0) {
        console.log("current bazaar..", bazaarList[currentIndex])
        setselectedBazaar(bazaarList[currentIndex])
      }
    }
  }, [bazaarList, state])

  const formik = useFormik({
    initialValues: {
      stall_type: "",
      stall_size: "",
      description: "",
      stall_number: "",
      base_price: "",
      two_sided_price: "",
      stall_cost: "",
      gst: 18,
    },
    validationSchema: Yup.object({
      stall_type: Yup.string().required("Stall Type is required"),
      stall_size: Yup.string().required("Stall Size is required"),
      stall_number: Yup.string().required("Stall Number is required"),
      base_price: Yup.string().required("Base Price is required"),
      // two_sided_price: Yup.string().required("Two Sided Price is required"),
      stall_cost: Yup.string().required("Stall Cost is required"),
      gst: Yup.string().required("GST percentage is required"),
    }),
    onSubmit: values => {
      console.log("values..", values)
      let requestBody = {
        enc_bazaar_id: selectedBazaar.enc_bazaar_id,
        stall_type: values.stall_type,
        stall_number: [values.stall_number],
        stall_size: values.stall_size,
        base_price: values.base_price,
        two_sides_price: values.two_sided_price,
        stall_cost: values.stall_cost,
        gst: values.gst,
        description: values.description,
      }
      console.log("requestBody..", requestBody)
      dispatch(addBazaarStallDetails(requestBody))
    },
  })

  useEffect(() => {
    console.log("formik..", formik.isSubmitting, formik.errors)
  }, [formik])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Form onSubmit={formik.handleSubmit}>
          <div className="mb-3"></div>
          <Card>
            <CardBody>
              <h4 className="font-size-18 mb-4">Add Stall</h4>
              <div className="border-top mt-3 pb-1 mb-2"></div>
              <div className="row align-items-center mt-3 mb-3">
                <div className="col-md-6 col-12">
                  <div className="row">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        Bazaar Name:
                      </Label>
                    </div>
                    <div className="col-12 col-sm-9">
                      <div className="mb-3">
                        <h4 className="font-size-16 mb-4">
                          {selectedBazaar?.bazaar_name}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_type">
                      Stall Type
                    </Label>
                    <Input
                      name="stall_type"
                      className="form-control"
                      placeholder="Stall Type"
                      value={formik.values.stall_type}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_type"
                      invalid={
                        formik.touched.stall_type && formik.errors.stall_type
                          ? true
                          : false
                      }
                    />
                    {formik.touched.stall_type && formik.errors.stall_type ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_type}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_no">
                      Stall No
                    </Label>
                    <Input
                      name="stall_number"
                      className="form-control"
                      placeholder="Stall No"
                      value={formik.values.stall_number}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_number"
                      invalid={
                        formik.touched.stall_number &&
                        formik.errors.stall_number
                          ? true
                          : false
                      }
                    />
                    {formik.touched.stall_number &&
                    formik.errors.stall_number ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_number}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>

                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_size">
                      Stall Size
                    </Label>
                    <Input
                      name="stall_size"
                      className="form-control"
                      placeholder="Stall size"
                      value={formik.values.stall_size}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_size"
                      invalid={
                        formik.touched.stall_size && formik.errors.stall_size
                          ? true
                          : false
                      }
                    />
                    {formik.touched.stall_size && formik.errors.stall_size ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_size}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      Base Price
                    </Label>
                    <Input
                      name="base_price"
                      className="form-control"
                      placeholder="0"
                      value={formik.values.base_price}
                      onChange={e => {
                        formik.setFieldValue(
                          "base_price",
                          Number(e.target.value)
                        )
                        formik.setFieldValue(
                          "stall_cost",
                          Number(e.target.value) +
                            Number(formik.values.two_sided_price)
                        )
                      }}
                      type="number"
                      id="base_price"
                      invalid={
                        formik.touched.base_price && formik.errors.base_price
                          ? true
                          : false
                      }
                    />
                    {formik.touched.base_price && formik.errors.base_price ? (
                      <FormFeedback type="invalid">
                        {formik.errors.base_price}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>

                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      2 Sided Price
                    </Label>
                    <Input
                      name="two_sided_price"
                      className="form-control"
                      placeholder="0"
                      value={formik.values.two_sided_price}
                      onChange={e => {
                        formik.setFieldValue(
                          "two_sided_price",
                          Number(e.target.value)
                        )
                        formik.setFieldValue(
                          "stall_cost",
                          Number(formik.values.base_price) +
                            Number(e.target.value)
                        )
                      }}
                      type="number"
                      id="two_sided_price"
                      invalid={
                        formik.touched.two_sided_price &&
                        formik.errors.two_sided_price
                          ? true
                          : false
                      }
                    />
                    {formik.touched.two_sided_price &&
                    formik.errors.two_sided_price ? (
                      <FormFeedback type="invalid">
                        {formik.errors.two_sided_price}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>

                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      Stall Cost
                    </Label>
                    <Input
                      name="stall_cost"
                      className="form-control"
                      placeholder="0"
                      value={formik.values.stall_cost}
                      onChange={e => {
                        formik.setFieldValue("stall_cost", Number(e.target.value))
                      }}
                      type="number"
                      id="stall_cost"
                      invalid={
                        formik.touched.stall_cost && formik.errors.stall_cost
                          ? true
                          : false
                      }
                    />
                    {formik.touched.stall_cost && formik.errors.stall_cost ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_cost}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      GST Percentage
                    </Label>
                    <Input
                      name="gst"
                      className="form-control"
                      placeholder="GST"
                      value={formik.values.gst}
                      onChange={formik.handleChange}
                      type="number"
                      id="gst"
                      invalid={
                        formik.touched.gst && formik.errors.gst ? true : false
                      }
                    />
                    {formik.touched.gst && formik.errors.gst ? (
                      <FormFeedback type="invalid">
                        {formik.errors.gst}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12 col-sm-8">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="description">
                      Description
                    </Label>
                    <textarea
                      name="description"
                      className="form-control"
                      placeholder="Description..."
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      rows={5}
                    ></textarea>
                    {formik.touched.description && formik.errors.description ? (
                      <FormFeedback type="invalid">
                        {formik.errors.description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-center">
            <Button
              type="submit"
              color="primary"
              size="md"
              className="btn btn-block font-size-16 mt-3"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
      <PageLoader open={addBazaarStallDetailsScreen.loading} />
    </div>
  )
}

export default AddSlots
